import {SSEDataAdapter} from "./SSEDataAdapter.js";
import type SSEClient from "./SSEClient.js";
import type {SessionItem} from "../session/SessionItem.js";
import {ref} from "vue";
import {MessageFactory} from "../factory/MessageFactory.js";

export class PredictSSEDataAdapter extends SSEDataAdapter{

    private session: SessionItem
    private pushMsg = false

    constructor(session: SessionItem) {
        super();
        this.session = session;
    }

    on_error_msg(data: string): void {

        this.session.lastMessage.isStreaming = false;
        this.session.lastMessage.content = data

    }

    on_success_msg(data: string): void {

        if(this.pushMsg) {
            const newMsg = ref(MessageFactory.createAiMsg())
            newMsg.value.isStreaming = true
            this.session.pushMessage(newMsg.value)
            this.pushMsg = false
        }

        let aiMsg = this.session.lastMessage

        const res = JSON.parse(data)
        if (res.msg_type === "json") {

            aiMsg.isStreaming = false
            // 历史数据
            aiMsg.msgType = "2"
            aiMsg.chartData = res.msg.history
            aiMsg.title = "既存データ"

            const newMsg = ref(MessageFactory.createAiMsg())
            newMsg.value.isStreaming = true
            this.session.pushMessage(newMsg.value)
            aiMsg = this.session.lastMessage

            aiMsg.isStreaming = false
            aiMsg.msgType = "2"
            aiMsg.chartData = res.msg.predict
            aiMsg.title = "予測データ"

            this.pushMsg = true

        } else if (res.msg_type === "text") {

            if(this.pushMsg) {
                const newMsg = ref(MessageFactory.createAiMsg())
                newMsg.value.isStreaming = true
                this.session.pushMessage(newMsg.value)
                this.pushMsg = false
            }

            let aiMsg = this.session.lastMessage

            aiMsg.isStreaming = false
            aiMsg.msgType = "0"
            aiMsg.content += res.msg  // ✅ res.msg 不是 res.data.msg

        }
    }

    on_end_msg(client: SSEClient) {
        super.on_end_msg(client);
    }

}